// crypto.randomUUID() only exists in SECURE contexts (https / localhost). When
// the app is served over plain http on a LAN IP (e.g. testing from a phone),
// it is undefined and throws. This helper degrades gracefully to
// crypto.getRandomValues, then Math.random, so storage-path generation keeps
// working in any context.
export function randomId(): string {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
    if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
      const bytes = crypto.getRandomValues(new Uint8Array(16));
      return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
    }
  } catch {
    /* fall through */
  }
  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;
}
